import React, { createElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import classnames from 'classnames';
import mapFacets from 'util/react/facet';
import CartNotification from './notifications/bags-progressbar';
import FlipMove from 'react-flip-move';
import { CART } from 'constants/snackbar-notifications';
import { snackbarEasingFn, snackbarSpeed } from 'constants/transitions-props';

const notificationsComponents = {
    [CART.type]: CartNotification,
};

class Snackbar extends PureComponent {
    static propTypes = {
        wasCartReset: PropTypes.bool.isRequired,
        wasCartFetched: PropTypes.bool.isRequired,
        customerDeliveryFee: PropTypes.string.isRequired,
        bagInfo: PropTypes.object.isRequired,
        removeNotification: PropTypes.func.isRequired,
        addNotification: PropTypes.func.isRequired,
        notifications: PropTypes.array.isRequired,
    };

    static getFirstNotification(collection) {
        return collection.length ? collection[0] : null;
    }

    componentWillReceiveProps({ notifications, wasCartReset, bagInfo, customerDeliveryFee, addNotification }) {
        const firstNotification = Snackbar.getFirstNotification(notifications);
        const oldNotification = Snackbar.getFirstNotification(this.props.notifications);

        // cart notifications should be handled a bit differently
        this.handleCartNotifications({ bagInfo, wasCartReset, addNotification, customerDeliveryFee });

        // handle any new notification, cart notifications included
        if (firstNotification && (!oldNotification || firstNotification.id !== oldNotification.id)) {
            this.setNotificationTimer(firstNotification);
        }
    }

    componentWillUnmount() {
        this.clearTimer();
    }

    handleCartNotifications({ bagInfo, wasCartReset, addNotification, customerDeliveryFee }) {
        const { non_full_bag_percentage } = bagInfo;
        const { wasCartFetched } = this.props;
        const cartNotification = Object.assign({
            bagInfo,
            price: customerDeliveryFee,
            oldBagInfo: this.props.bagInfo,
        }, CART);

        if (wasCartFetched && !wasCartReset && non_full_bag_percentage !== this.props.bagInfo.non_full_bag_percentage) {
            addNotification({ notification: cartNotification });
        }

        this.setNotificationTimer(cartNotification);
    }

    setNotificationTimer(notification) {
        this.clearTimer();

        this.timer = setTimeout(() => {
            this.props.removeNotification({ notification });
        }, notification.delay);
    }

    clearTimer() {
        clearTimeout(this.timer);
    }

    timer = null;

    get transitions() {
        return {
            enterAnimation: {
                from: {
                    transform: 'translate(0, 100%)',
                },
                to: {
                    transform: 'translate(0, 0)',
                },
            },
            leaveAnimation: {
                from: {
                    transform: 'translate(0, 0)',
                },
                to: {
                    transform: 'translate(0, 100%)',
                },
            },
        };
    }

    render() {
        const { notifications } = this.props;
        const notification = Snackbar.getFirstNotification(notifications);

        return (
            <div ref="root" className="snackbar">
                <FlipMove
                    typeName="ol"
                    className="snackbar--list u-reset"
                    maintainContainerHeight={true}
                    staggerDelayBy={snackbarSpeed}
                    duration={snackbarSpeed}
                    easing={snackbarEasingFn}
                    {...this.transitions}>
                    {notification && (
                        <li key={notification.id} className="snackbar--item">
                            <div
                                className={classnames('snackbar--notification', mapFacets(notification.type, 'snackbar--notification'))}>
                                {createElement(notificationsComponents[notification.type], {
                                    ...notification,
                                })}
                            </div>
                        </li>
                    )}
                </FlipMove>
            </div>
        );
    };
}

export default connect(
    reduxUtils.mapStateToProps({
        bagInfo: 'cart.bagInfo',
        customerDeliveryFee: 'cart.customerDeliveryFee',
        wasCartReset: 'cart.wasReset',
        wasCartFetched: 'cart.wasFetched',
        notifications: 'snackbar.items',
    }),
    reduxUtils.mapDispatchToProps({
        removeNotification: 'snackbar.remove',
        addNotification: 'snackbar.add',
    }),
)(Snackbar);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/snackbar/index.js